import { Component, OnInit } from '@angular/core';
import { SystemUserService } from 'src/app/services/system-user.service';
import { PaginationInstance } from 'ngx-pagination';

@Component({
  standalone: false,
  selector: 'app-system-user-listing',
  templateUrl: './system-user-list.component.html',
})
export class SystemUserListingComponent implements OnInit {
  users: any = [];
  currentPage = 1;
  paginationConfig: PaginationInstance = {
    id: 'system_user_listing',
    itemsPerPage: 10,
    totalItems: 0,
    currentPage: 1,
  };

  constructor(private systemUserService: SystemUserService) {}

  ngOnInit(): void {
    this.getSystemUsers(this.currentPage);
  }

  getSystemUsers(page = 1): void {
    this.systemUserService.getAllSystemUser(page).subscribe((result) => {
      this.users = result.data;
      this.paginationConfig.currentPage = result.current_page;
      this.paginationConfig.totalItems = result.total;
      this.paginationConfig.itemsPerPage = result.per_page;
    });
  }
}